import produce from 'immer';

export const actionTypes = {
  PAGE_CHANGED: 'PAGE_CHANGED',
  PAGE_SIZE_CHANGED: 'PAGE_SIZE_CHANGED',
  SORT_CHANGED: 'SORT_CHANGED',
  FILTER_CHANGED: 'FILTER_CHANGED',
  FILTER_TOGGLED: 'FILTER_TOGGLED',
  FILTERS_RESET: 'FILTERS_RESET',
  COLUMNS_CHANGED: 'COLUMNS_CHANGED',
  DATA_LOADED: 'DATA_LOADED',
  LOADING_CHANGED: 'LOADING_CHANGED',
  LOAD_FAILED: 'LOAD_FAILED'
};

// Any filter change resets to the first page: leaving skip where it was strands
// the user on an empty page whenever the new filter returns fewer rows.
export const reducer = produce((draft, action) => {
  switch (action.type) {
    case actionTypes.PAGE_CHANGED:
      // Quimby's Pagination is 1-indexed; the datatable params helper wants
      // Kendo's skip/take.
      draft.page.skip = (action.page - 1) * draft.page.take;
      break;
    case actionTypes.PAGE_SIZE_CHANGED:
      draft.page = { skip: 0, take: action.pageSize };
      break;
    case actionTypes.SORT_CHANGED:
      draft.sort = action.sort;
      draft.page.skip = 0;
      break;
    case actionTypes.FILTER_CHANGED:
      draft.filters.values[action.field] = action.value;
      draft.page.skip = 0;
      break;
    case actionTypes.FILTER_TOGGLED:
      draft.filters.active[action.field] = !draft.filters.active[action.field];
      if (!draft.filters.active[action.field]) draft.filters.values[action.field] = '';
      draft.page.skip = 0;
      break;
    case actionTypes.FILTERS_RESET:
      draft.filters = action.filters;
      draft.page.skip = 0;
      break;
    case actionTypes.COLUMNS_CHANGED:
      draft.columns = action.columns;
      break;
    case actionTypes.DATA_LOADED:
      draft.data = action.data.data;
      draft.totalCount = action.data.total_count;
      draft.loading = false;
      draft.failed = false;
      break;
    case actionTypes.LOADING_CHANGED:
      draft.loading = action.loading;
      break;
    case actionTypes.LOAD_FAILED:
      draft.loading = false;
      draft.failed = true;
      break;
    default:
      break;
  }
});
